import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button as ButtonBootstrap } from 'reactstrap';
import propTypes from 'prop-types';

export default class Button extends Component{
  render(){
    return (
      <ButtonBootstrap
        id={this.props.id}
        disabled={this.props.disabled}
        size={this.props.size}
        block={this.props.block}
        style={this.props.style}
        className={this.props.className}
        onClick={this.props.onClick}
      >
          {this.props.children || ((this.props.disabled && !this.props.social) ? this.props.loadingText:this.props.buttonText)}
      </ButtonBootstrap>
    )
  }
}
Button.propTypes={
  disabled:propTypes.bool,
  loadingText:propTypes.string,
  className:propTypes.string,
  block:propTypes.bool,
  size:propTypes.string,
  buttonText:propTypes.string
}
Button.defaultProps={
  loadingText:'Submitting...',
  className:'',
  size:'md',
}
